export const DOCUMENT_MIN_WIDTH:number = 150;
export const DOCUMENT_MAX_WIDTH:number = 18000;
export const DOCUMENT_MIN_HEIGHT:number = 150;
export const DOCUMENT_MAX_HEIGHT:number = 18000;
export const DOCUMENT_MIN_DPI:number = 1;
export const DOCUMENT_MAX_DPI:number = 150;
export const DOCUMENT_MAX_PIXELS:number = 1000000;
export const DOCUMENT_DATA_DPI:number = 150;
export const DOCUMENT_MIN_REPEAT:number = 1;
export const DOCUMENT_MAX_REPEAT:number = 12;

export const PIXEL_TO_CM_FACTOR:number = 2.54;
export const PIXEL_TO_CM:number = DOCUMENT_DATA_DPI / PIXEL_TO_CM_FACTOR;

export const DOCUMENT_QUALITY_TICK:number = 25;
export const DOCUMENT_QUALITY_CHECK:number = 250;
export const DOCUMENT_QUALITY_MAX:number = 100;
export const DOCUMENT_QUALITY_MIN:number = 10;
export const DOCUMENT_QUALITY_THRESHOLD_UP:number = 30;
export const DOCUMENT_QUALITY_THRESHOLD_DOWN:number = 25;

export const DOCUMENT_MAX_RESIZE_PER_SECOND:number = 1;
export const DOCUMENT_ZOOM_STEP:number = 10;
export const STAGE_ZOOM_AMOUNT:number = 0.01;
export const WEBGL_MAX_SIZE:number = 16384;
export const WEBGL_MAX_CHUNK_SIZE:number = 8192;

export const LOW_DPI_THRESHOLD = DOCUMENT_DATA_DPI / 3 * 2;

export const CREATE_LAB_MIN_WINDOW_WIDTH:number = 960;
export const CREATE_LAB_MIN_WINDOW_HEIGHT:number = 600;

export const DELAYED_INPUT_DELAY_MS:number = 500